import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ElevatorIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ElevatorIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M21.0625 2.4502H2.9375C2.42059 2.4502 2 2.87079 2 3.3877V21.5127C2 22.0296 2.42059 22.4502 2.9375 22.4502H21.0625C21.5794 22.4502 22 22.0296 22 21.5127V3.3877C22 2.87079 21.5794 2.4502 21.0625 2.4502ZM12.586 9.58564H17.5442V21.2783H12.586V9.58564ZM11.4141 21.2783H6.45586V9.58564H11.4141V21.2783ZM20.8281 21.2783H18.716V8.9997C18.716 8.67611 18.4537 8.41376 18.1301 8.41376H5.86992C5.54633 8.41376 5.28398 8.6761 5.28398 8.9997V21.2783H3.17187V3.62207H20.8281V21.2783Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M7.69703 7.12405C7.9607 7.31155 8.32652 7.24987 8.51414 6.98624L8.93512 6.3944L9.3561 6.98624C9.5438 7.25007 9.90969 7.31151 10.1732 7.12405C10.4369 6.93647 10.4986 6.57065 10.311 6.30694L9.41258 5.04393C9.17906 4.71569 8.69098 4.71596 8.45766 5.04393L7.55922 6.30694C7.37164 6.57061 7.43332 6.93643 7.69703 7.12405Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.5875 6.9865C14.821 7.31474 15.3091 7.31447 15.5424 6.9865L16.4409 5.72349C16.6285 5.45982 16.5667 5.09397 16.3031 4.90638C16.0394 4.7188 15.6735 4.78052 15.486 5.04419L15.065 5.63603L14.644 5.04419C14.4564 4.78048 14.0906 4.7188 13.8269 4.90638C13.5632 5.09397 13.5015 5.45978 13.6891 5.72349L14.5875 6.9865Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ElevatorIcon;
